export var ORIGIN = 'Wix Events';
export var LIST = 'Widget';
export var EVENT_CATEGORY = 'Enhanced Ecommerce';
export var EVENTS;
(function (EVENTS) {
    EVENTS["AddToCard"] = "AddToCart";
    EVENTS["RemoveFromCart"] = "RemoveFromCart";
    EVENTS["ViewContent"] = "ViewContent";
    EVENTS["InitiateCheckout"] = "InitiateCheckout";
    EVENTS["AddPaymentInfo"] = "AddPaymentInfo";
    EVENTS["Purchase"] = "Purchase";
    EVENTS["CustomEvent"] = "CustomEvent";
    EVENTS["ClickProduct"] = "ClickProduct";
    EVENTS["WidgetView"] = "Widget View";
})(EVENTS || (EVENTS = {}));
export var TICKET_TYPE;
(function (TICKET_TYPE) {
    TICKET_TYPE["Free"] = "free";
    TICKET_TYPE["Regular"] = "regular";
})(TICKET_TYPE || (TICKET_TYPE = {}));
//# sourceMappingURL=index.js.map